/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const StyledInputPassword = styled.div`
  position: relative;
  width: 100%;
  & input {
    width: 100%;
    height: 48px;
    padding: 10px 50px;
    font-size: 14px;
    color: #383838;
    border: 1px solid;
    /* border-color: #646569; */
    border-color: ${(props) => props.borderColor || '#646569'};
    border-radius: 4px;
    /* margin: 8px 0px; */
  }
  & img {
    position: absolute;
    width: 18px;
    top: 14px;
    right: 24px;
  }
  & .btn-show-password img {
    right: 20px;
  }
  /* & .input-password-success {
    border-color: #0e891a;
  }
  & .input-password-error {
    border-color: #cc284e;
  } */
  & .img-padlock {
    left: 20px;
    width: 12px;
  }
  & input:focus {
    /* border: 1px solid; */
    outline: none !important;
    /* box-shadow: 0 0 10px #719ECE; */
    border-color: ${(props) => props.borderColor || '#646569'};
  }
`;
